module.exports = __webpack_public_path__ + "img/JourneyCardScreenshot-1250h.e8181fcb.webp";